const apiVersion = 'v1'

export const BASE_PATH = `api/${apiVersion}/clients/:client_session_id/sources/`
export const TABLES_GENERATED_PATH = `api/${apiVersion}/clients/:client_session_id/tables-generated/`
